import { render } from "./PanelAdminFAQChange.vue?vue&type=template&id=33bde6e0&scoped=true&ts=true"
import script from "./PanelAdminFAQChange.vue?vue&type=script&lang=ts"
export * from "./PanelAdminFAQChange.vue?vue&type=script&lang=ts"

import "./PanelAdminFAQChange.vue?vue&type=style&index=0&id=33bde6e0&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bde6e0"]])

export default __exports__